<template>
  <div>
    <v-container grid-list-md class="relatorios-comparativos-container">
      <v-layout row wrap class="equal-heights px-5 pb-5 pt-5 comparativo-row">
        <v-flex xs12 md6 class="comparativo-col" id="printStatus">
          <v-card class="px-4 py-3 mr-4">
            <div class="comparativo-titulo">
              <strong>Status</strong>
            </div>
            <v-card-text style="position: relative; height: calc(100% - 52px);">
              <div class="print-title">
                <strong>Status</strong>
                <small>Relatório gerado em {{ data }}</small>
              </div>
              <div class="graph-legend">
                <div class="legend" v-html="legendChart.status"></div>
              </div>
              <div class="graph-container">
                <PieChart :chartdata="dataChart.status" v-if="dataLoaded" @generated="setLegend($event, 'status')"></PieChart>
              </div>
            </v-card-text>
            <v-card-actions style="width: 100%;">
              <v-btn outline class="mr-0 grey grey--text" @click.native="printGraph('printStatus', 'Status')" :disabled="gerandoPdf" v-if="dataLoaded">Baixar relatório</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 class="comparativo-col" id="printSubstatus">
          <v-card class="px-4 py-3 ml-4">
            <div class="comparativo-titulo">
              <strong>Sub-status</strong>
              <ul class="opcoes" v-if="dataLoaded">
                <li v-for="substatus in Object.keys(dataChart.substatus)" :class="{ 'ativo': substatusSelecionado === substatus }" @click="changeSubstatusSelecionado(substatus)">
                  <strong>{{ substatus }}</strong>
                </li>
              </ul>
            </div>
            <v-card-text style="position: relative; height: calc(100% - 52px);">
              <div class="print-title">
                <strong>Sub-status</strong>
                <small>Relatório gerado em {{ data }}</small>
              </div>
              <div v-for="substatus in Object.keys(dataChart.substatus)" v-if="dataLoaded" v-show="substatusSelecionado === substatus">
                <div class="graph-legend">
                  <div class="legend" v-html="legendChart[substatus.toLowerCase()]"></div>
                </div>
                <div class="graph-container">
                  <PieChart :chartdata="dataChart.substatus[substatus]" @generated="setLegend($event, substatus.toLowerCase())"></PieChart>
                </div>
              </div>
            </v-card-text>
            <v-card-actions style="width: 100%;">
              <v-btn outline class="mr-0 grey grey--text" @click.native="printGraph('printSubstatus', 'Sub-status (' + substatusSelecionado + ')')" :disabled="gerandoPdf" v-if="dataLoaded">Baixar relatório</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="equal-heights px-5 pb-5 comparativo-row">
        <v-flex xs12 md6 class="comparativo-col" id="printProprietario">
          <v-card class="px-4 py-3 mr-4" height="100%" style="min-height: 542px;">
            <div class="comparativo-titulo">
              <strong>Proprietário</strong>
            </div>
            <v-card-text style="position: relative; height: calc(100% - 52px);">
              <div class="print-title">
                <strong>Proprietário</strong>
                <small>Relatório gerado em {{ data }}</small>
              </div>
              <div class="graph-legend">
                <div class="legend" v-html="legendChart.proprietario"></div>
              </div>
              <div class="graph-container">
                <PieChart :chartdata="dataChart.proprietario" v-if="dataLoaded" @generated="setLegend($event, 'proprietario')"></PieChart>
              </div>
            </v-card-text>
            <v-card-actions style="width: 100%;">
              <v-btn outline class="mr-0 grey grey--text" @click.native="printGraph('printProprietario', 'Proprietário')" :disabled="gerandoPdf" v-if="dataLoaded">Baixar relatório</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 class="comparativo-col" id="printVistoria">
          <v-card class="px-4 py-3 ml-4">
            <div class="comparativo-titulo">
              <strong>Vistoria</strong>
            </div>
            <v-card-text style="position: relative; height: calc(100% - 52px);">
              <div class="print-title">
                <strong>Vistoria</strong>
                <small>Relatório gerado em {{ data }}</small>
              </div>
              <div class="graph-legend">
                <div class="legend" v-html="legendChart.vistoria"></div>
              </div>
              <div class="graph-container">
                <PieChart :chartdata="dataChart.vistoria" v-if="dataLoaded" @generated="setLegend($event, 'vistoria')"></PieChart>
              </div>
            </v-card-text>
            <v-card-actions style="width: 100%;">
              <v-btn outline class="mr-0 grey grey--text" @click.native="printGraph('printVistoria', 'Vistoria')" :disabled="gerandoPdf" v-if="dataLoaded">Baixar relatório</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="equal-heights px-5 pb-5 comparativo-row">
        <v-flex xs12 md6 class="comparativo-col" id="printTipo">
          <v-card class="px-4 py-3 mr-4">
            <div class="comparativo-titulo">
              <strong>Tipo</strong>
            </div>
            <v-card-text style="position: relative; height: calc(100% - 52px);">
              <div class="print-title">
                <strong>Tipo</strong>
                <small>Relatório gerado em {{ data }}</small>
              </div>
              <div class="graph-legend">
                <div class="legend" v-html="legendChart.tipo"></div>
              </div>
              <div class="graph-container">
                <PieChart :chartdata="dataChart.tipo" v-if="dataLoaded" @generated="setLegend($event, 'tipo')"></PieChart>
              </div>
            </v-card-text>
            <v-card-actions style="width: 100%;">
              <v-btn outline class="mr-0 grey grey--text" @click.native="printGraph('printTipo', 'Tipo')" :disabled="gerandoPdf" v-if="dataLoaded">Baixar relatório</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 class="comparativo-col" id="printTarefas">
          <v-card class="px-4 py-3 ml-4">
            <div class="comparativo-titulo">
              <strong>Tarefas</strong>
            </div>
            <v-card-text style="position: relative; height: calc(100% - 52px);">
              <div class="print-title">
                <strong>Tarefas</strong>
                <small>Relatório gerado em {{ data }}</small>
              </div>
              <div class="graph-legend">
                <div class="legend" v-html="legendChart.tarefas"></div>
              </div>
              <div class="graph-container">
                <PieChart :chartdata="dataChart.tarefas" v-if="dataLoaded" @generated="setLegend($event, 'tarefas')"></PieChart>
              </div>
            </v-card-text>
            <v-card-actions style="width: 100%;">
              <v-btn outline class="mr-0 grey grey--text" @click.native="printGraph('printTarefas', 'Tarefas')" :disabled="gerandoPdf" v-if="dataLoaded">Baixar relatório</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="equal-heights px-5 pb-5 comparativo-row">
        <v-flex xs12 md6 class="comparativo-col" id="printIptu">
          <v-card class="px-4 py-3 mr-4" height="100%" style="min-height: 542px;">
            <div class="comparativo-titulo">
              <strong>IPTU</strong>
            </div>
            <v-card-text style="position: relative; height: calc(100% - 52px);">
              <div class="print-title">
                <strong>IPTU</strong>
                <small>Relatório gerado em {{ data }}</small>
              </div>
              <div class="graph-legend">
                <div class="legend" v-html="legendChart.iptu"></div>
              </div>
              <div class="graph-container">
                <PieChart :chartdata="dataChart.iptu" v-if="dataLoaded" @generated="setLegend($event, 'iptu')"></PieChart>
              </div>
            </v-card-text>
            <v-card-actions style="width: 100%;">
              <v-btn outline class="mr-0 grey grey--text" @click.native="printGraph('printIptu', 'IPTU')" :disabled="gerandoPdf" v-if="dataLoaded">Baixar relatório</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 class="comparativo-col" id="printCidade">
          <v-card class="px-4 py-3 ml-4">
            <div class="comparativo-titulo">
              <strong>Cidade</strong>
            </div>
            <v-card-text style="position: relative; height: calc(100% - 52px);">
              <div class="print-title">
                <strong>Cidade</strong>
                <small>Relatório gerado em {{ data }}</small>
              </div>
              <table>
                <tr v-for="(total, cidade) in this.comparativo.cidade">
                  <td>{{ cidade }}</td>
                  <td><span>{{ total }}</span> &nbsp; {{ Math.floor(((total / totalCidades) * 100) + 0.5) }}%</td>
                </tr>
              </table>
            </v-card-text>
            <v-card-actions style="width: 100%;">
              <v-btn outline class="mr-0 grey grey--text" @click.native="printGraph('printCidade', 'Cidade')" :disabled="gerandoPdf" v-if="dataLoaded">Baixar relatório</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import _ from 'lodash'
  import PieChart from './Charts/Pie.js'
  import moment from 'moment'
  import html2pdf from 'html2pdf.js'

  export default {
    components: { PieChart },
    data () {
      return {
        unsubscribe: null,
        dataLoaded: false,
        dataChart: {
          status: null,
          substatus: {},
          proprietario: null,
          tipo: null,
          iptu: null,
          vistoria: null,
          tarefas: null
        },
        legendChart: {
          status: null,
          compromissado: null,
          locado: null,
          invadido: null,
          proprietario: null,
          tipo: null,
          iptu: null,
          vistoria: null,
          tarefas: null
        },
        substatusSelecionado: null,
        data: moment().format('DD/MM/YYYY [às] HH:mm:ss'),
        gerandoPdf: false,
        totalCidades: 0
      }
    },
    async mounted () {
      this.clearComparativo()
      this.loadComparativo()

      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'imoveis/SET_FILTROS') {
          this.clearComparativo()
          this.loadComparativo()
        }
      })
    },
    beforeDestroy () {
      this.unsubscribe()
    },
    computed: {
      comparativo () {
        return this.$store.getters['relatorios/comparativo']
      },
      filtros () {
        return this.$store.getters['imoveis/filtros']
      }
    },
    watch: {
      comparativo () {
        if (Object.keys(this.comparativo).length > 0) {
          // Status
          this.dataChart.status = this.buildChartData(this.comparativo.status)
          // Sub-status (Compromissado)
          if (this.comparativo.substatus['Compromissado']) {
            this.dataChart.substatus['Compromissado'] = this.buildChartData(this.comparativo.substatus['Compromissado'])
          }
          // Sub-status (Locado)
          if (this.comparativo.substatus['Locado']) {
            this.dataChart.substatus['Locado'] = this.buildChartData(this.comparativo.substatus['Locado'])
          }
          // Sub-status (Invadido)
          if (this.comparativo.substatus['Invadido']) {
            this.dataChart.substatus['Invadido'] = this.buildChartData(this.comparativo.substatus['Invadido'])
          }
          // Sub-status (selecionar o primeiro)
          this.substatusSelecionado = Object.keys(this.dataChart.substatus)[0]
          // Proprietário
          this.dataChart.proprietario = this.buildChartData(this.comparativo.proprietario)
          // Tipo
          this.dataChart.tipo = this.buildChartData(this.comparativo.tipo)
          // IPTU
          this.dataChart.iptu = this.buildChartData(this.comparativo.iptu)
          // Vistoria
          this.dataChart.vistoria = this.buildChartData(this.comparativo.vistoria)
          // Tarefas
          this.dataChart.tarefas = this.buildChartData(this.comparativo.tarefas)
          // Cidade
          let sum = _.reduce(this.comparativo.cidade, (acc, n) => {
            return acc + n
          })
          this.totalCidades = sum

          // Loaded
          this.dataLoaded = true
        }
      },
      filtros () {
        this.dataLoaded = false
      }
    },
    methods: {
      buildChartData (source) {
        const safeSource = _.isObject(source) ? source : {}
        const labels = Object.keys(safeSource)
        const values = _.map(safeSource, 'total')
        const apiColors = _.map(safeSource, 'color')
        const backgroundColor = this.getDistinctColors(apiColors, labels.length)

        return {
          labels,
          datasets: [
            {
              backgroundColor: backgroundColor,
              data: values
            }
          ]
        }
      },
      getDistinctColors (apiColors, size) {
        const palette = [
          '#F37021', '#1E88E5', '#43A047', '#E53935', '#8E24AA',
          '#FB8C00', '#00ACC1', '#7CB342', '#6D4C41', '#3949AB',
          '#D81B60', '#5E35B1', '#039BE5', '#00897B', '#C0CA33',
          '#546E7A', '#EF6C00', '#C62828', '#2E7D32', '#1565C0'
        ]
        const used = {}
        const colors = []

        for (let i = 0; i < size; i++) {
          const color = apiColors[i] ? apiColors[i].trim() : ''
          if (this.isValidColor(color) && !used[color.toLowerCase()]) {
            colors.push(color)
            used[color.toLowerCase()] = true
            continue
          }

          let fallbackColor = null
          for (let p = 0; p < palette.length; p++) {
            const paletteColor = palette[p]
            if (!used[paletteColor.toLowerCase()]) {
              fallbackColor = paletteColor
              break
            }
          }

          // If palette is exhausted, generate deterministic HSL colors.
          if (!fallbackColor) {
            let seed = i
            do {
              const hue = (seed * 137.508) % 360
              fallbackColor = `hsl(${Math.round(hue)}, 65%, 50%)`
              seed++
            } while (used[fallbackColor.toLowerCase()])
          }

          colors.push(fallbackColor)
          used[fallbackColor.toLowerCase()] = true
        }

        return colors
      },
      isValidColor (value) {
        return !!value && typeof value === 'string' && value.trim().length > 0
      },
      printGraph (element, name) {
        this.$store.dispatch('utils/showLoading')
        this.gerandoPdf = true

        setTimeout(() => {
          this.data = moment().format('DD/MM/YYYY [às] HH:mm:ss')
          html2pdf(document.getElementById(element), {
            margin: 2,
            filename: `Relatório - ${name} - ${moment().format('DD.MM.YYYY')}.pdf`,
            image: {
              type: 'jpeg',
              quality: 1
            },
            html2canvas: {
              dpi: 300,
              windowWidth: 10
            }
          }).then(() => {
            this.$store.dispatch('utils/hideLoading')
            this.gerandoPdf = false
          })
        }, 500)
      },
      setLegend (html, legend) {
        this.legendChart[legend] = html
      },
      clearComparativo () {
        this.$store.dispatch('relatorios/clearComparativo')
      },
      loadComparativo () {
        const payload = {}

        if (!_.isEmpty(this.filtros)) {
          Object.assign(payload, this.filtros)
        }

        this.$store.dispatch('relatorios/loadComparativo', payload)
      },
      changeSubstatusSelecionado (substatus) {
        this.substatusSelecionado = substatus
      }
    }
  }
</script>

<style>
.comparativo-titulo { position: absolute; top: -28px; left: 1px; width: 100%; }
.comparativo-titulo > strong { color: rgba(243, 112, 33, .82); text-transform: uppercase; font-size: 16px; }

.graph-legend { float: left; width: 182px; }
.graph-container { position: absolute; right: 0; width: calc(100% - 230px); height: 100%; top: 0; }
.graph-container canvas { position: absolute; max-width: 100%; max-height: 100%; width: auto !important; height: auto !important; top: 50%; left: 50%; transform: translate(-50%, -50%); }

.print-title { display: none; }

@media screen and (max-width: 20px) {
  .print-title { display: block; width: 100%; float: left; margin-bottom: 50px; }
  .print-title > strong { color: rgba(243, 112, 33, .82); text-transform: uppercase; font-size: 24px; width: 100%; display: block; float: left; }
  .print-title { color: black; font-size: 14px; display: block; width: 100%; float: left; }

  .graph-container { position: relative; right: auto; top: auto; float: left; text-align: center; width: calc(100% - 182px); }
  .graph-container canvas { position: relative; top: auto; left: auto; max-width: 400px; max-height: 400px; float: right; margin-top: 50%; transform: translateY(-50%); }

  .card__actions { display: none; }

  .comparativo-col > div { margin-left: 0 !important; margin-right: 0 !important; }
}

@media screen and (max-width: 959px) {
  .relatorios-comparativos-container.container {
    max-width: 100% !important;
    width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .comparativo-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .comparativo-col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .graph-legend {
    width: 100%;
    float: none;
  }

  .graph-container {
    position: relative;
    width: 100%;
    right: auto;
    top: auto;
    height: 300px;
    margin-top: 10px;
  }

  .graph-container canvas {
    max-width: 300px;
    max-height: 300px;
  }

  .comparativo-col > .card {
    margin-left: 0 !important;
    margin-right: 0 !important;
    border-radius: 0;
  }

  .equal-heights.px-5 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
</style>

<style scoped>
.opcoes { color: #7D7D7D; font-size: 12px; list-style: none; margin-left: 28px; padding-left: 0; margin-bottom: 10px; display: inline-block; }
.opcoes li { margin-right: 24px; display: inline-block; cursor: pointer; }
.opcoes li.ativo { color: #FF7715; }

table { font-size: 16px; color: #737373; font-weight: bold; width: 100%; border-collapse: collapse; }
table span { font-size: 20px; color: black; }
table tr > td:first-of-type { padding-left: 18px; }
table tr > td:last-of-type { padding-right: 18px; text-align: right; }
table tr > td { border: 0; }
table tr:nth-of-type(even) { background: rgba(119, 119, 119, .09); }
</style>



// WEBPACK FOOTER //
// RelatoriosComparativos.vue?15cb39c6